<p class="subscription__cardTitle">{{ 'subscription-cancel-feedback' | translate }}</p>
@for (reason of reasons; track reason) {
  <app-radio-icon
    uid="cancel-subscription-reason"
    [label]="'cancel-subscription-reason--' + reason | translate"
    [selected]="reason === selectedReason"
    (click)="selectedReason = reason"
  />
}

<app-button
  [disabled]="!selectedReason"
  uid="confirm-cancel-subscription-button"
  text="blue"
  label="{{ 'changeplan-btn-cancelSubs' | translate }}"
  (click)="selectReason()"
/>
